import {useState} from 'react';
import './index.css';

const FormQuestion = ({id,value,onChange}) => {

        //hooks using useState for access to states
        //removing to give access to parent
        /*const [formQuestion, setformQuestion] = useState({
            question: "",
          });*/
        
        

      /*  const onChange = (e) => {
            setformQuestion({...formQuestion,[e.target.id]:e.target.value});
            console.log(e.target.value);
            //value=e.target.value;
            //console.log(value);
        };*/

        return (
            <textarea 
            type="text" 
            //id="question" 
            id={id}
            name="question" 
            placeholder="What would you like to know?" 
            //value={formQuestion.question}
            value={value}
            onChange={onChange} ></textarea>
          
        );
};

export default FormQuestion;